import { Pipe, PipeTransform } from '@angular/core';
import { getDateFormatLanguage } from '../utils/date';

@Pipe({
  name: 'formatDate2',
  standalone: true,
})
export class FormatDate2Pipe implements PipeTransform {
  transform(date: string | null, language = 'es'): string {
    if (!date) return 'yyyy-mm-dd';

    const [dates] = date.split(' ');
    const [day, month, year] = dates.split('-').map(Number);
    return getDateFormatLanguage({ year, month, day, language });
  }
}
